import axios from 'axios'

export const searchCities = (body) =>
  axios
    .post('/mobiville/api/cities/search', body)
    .then((response) => response.data || null)

export const fetchAutocompleteCities = (body) =>
  axios
    .post('/mobiville/api/cities/autocomplete', body)
    .then((response) => response.data || null)

export const getCriterions = () =>
  axios
    .get('/mobiville/api/cities/criterions')
    .then((response) => response.data || null)

export const loadCity = (insee) =>
  axios
    .get(`/mobiville/api/cities/load/${insee}`)
    .then((response) => response.data || null)

export const searchCloseCities = (body) =>
  axios
    .post('/mobiville/api/cities/search-close-cities', body)
    .then((response) => response.data || null)

export const searchSimilarCities = (body) =>
  axios
    .post('/mobiville/api/cities/search-similar-cities', body)
    .then((response) => response.data || null)

export const searchJobLabels = (body) =>
  axios
    .post('/mobiville/api/cities/search-by-label', body)
    .then((response) => response.data || [])

export const searchCloseCompanies = (body) =>
  axios
    .post(`/mobiville/api/cities/search-close-companies`, body)
    .then((response) => response.data || null)
